import React from "react";
import { useStaticQuery, graphql } from "gatsby";

const UseFooter = () => {
  const data = useStaticQuery(graphql`
    {
      contentfulFooter {
        featuredSection {
          image {
            url
            title
          }
          title
          headline
        }
        needHelp {
          title
          slug
        }
        aboutUs {
          title
          slug
        }
        subscribeHeadline
        socialLinks {
          image {
            title
            url
          }
          title
          link
        }
        paymentOptions {
          image {
            title
            url
          }
          title
        }
      }
    }
  `);
  return data.contentfulFooter;
};

export default UseFooter;
